import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import '../core/system.js';
import { typography } from './typography.js';
import { transition } from './transition.js';
import './margin.js';
import './padding.js';
import { space } from './space.js';
import { shadow } from './shadow.js';
import { animation } from './animation.js';
import { background } from './background.js';
import { border } from './border.js';
import { color } from './color.js';
import { flexbox } from './flexbox.js';
import { grid } from './grid.js';
import { layout } from './layout.js';
import { other } from './other.js';
import { position } from './position.js';

const parsers = compose(animation, background, border, color, flexbox, grid, layout, other, position, shadow, space, transition, typography);

export { parsers };
